import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCasinoProviders } from '../../store/actions/casino.actions';
import NewLoading from '../../Components/Common/NewLoading';
import Categories from './Categories';
import { NavLink } from 'react-router-dom';
import GameList from './GameList';
import { Translate } from '../../localization';

const Providers = () => {

    const dispatch = useDispatch();
    const { casinoProviders, casinoSearchValue } = useSelector((state) => state.casino);

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        document.title = `Provider - JackpotCT`;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute(
                'content',
                `Play your favorite Online Casino table games, including
        blackjack, roulette, and baccarat, with real dealers in an
        immersive online environment`
            );
        }
        const canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.setAttribute(
                'href',
                `https://www.jackpotct.com/${Translate.getLanguage()}/d/casino/providers`
            );
        }

    }, []);
    useEffect(() => {
        dispatch(getCasinoProviders(() => setLoading(false)));
    }, []);
    return (
        <div id='scrollableDiv'>
            <div className='category-slider'> <Categories /> </div>
            {loading ?
                <NewLoading customClass="casino-loader" />
                :
                casinoSearchValue.length == 0 ?
                    (casinoProviders.length > 0 ?
                        <div className='provider-section'>
                            {casinoProviders.map((provider, index) => {
                                return (
                                    <NavLink className='provider-card' key={index} to={`/${Translate.getLanguage()}/d/casino/providers/${provider[0]}`}>
                                        <img src={`/img/Providers/${provider[1]}.png`} alt="Provider's Image" />
                                        <p> {provider[1]} </p>
                                    </NavLink>
                                );
                            })}
                        </div>
                        :
                        <div className="fs-15 pt-3 pb-3 text-white">Nothing Found</div>)
                    : <GameList home={true} />
            }
        </div>
    );
};

export default Providers;